export * from './authController.service';
import { AuthControllerService } from './authController.service';
export * from './basicErrorController.service';
import { BasicErrorControllerService } from './basicErrorController.service';
export * from './dashboardController.service';
import { DashboardControllerService } from './dashboardController.service';
export * from './departmentController.service';
import { DepartmentControllerService } from './departmentController.service';
export * from './expensesController.service';
import { ExpensesControllerService } from './expensesController.service';
export * from './expensesHistoryController.service';
import { ExpensesHistoryControllerService } from './expensesHistoryController.service';
export * from './fileUploadController.service';
import { FileUploadControllerService } from './fileUploadController.service';
export * from './inventoryController.service';
import { InventoryControllerService } from './inventoryController.service';
export * from './inventoryOrderController.service';
import { InventoryOrderControllerService } from './inventoryOrderController.service';
export * from './kitchenController.service';
import { KitchenControllerService } from './kitchenController.service';
export * from './kitchenOrderController.service';
import { KitchenOrderControllerService } from './kitchenOrderController.service';
export * from './membershipController.service';
import { MembershipControllerService } from './membershipController.service';
export * from './merchantController.service';
import { MerchantControllerService } from './merchantController.service';
export * from './merchantVsPrinterController.service';
import { MerchantVsPrinterControllerService } from './merchantVsPrinterController.service';
export * from './merchantVsReceiptTemplateController.service';
import { MerchantVsReceiptTemplateControllerService } from './merchantVsReceiptTemplateController.service';
export * from './merchantVsSubscriptionController.service';
import { MerchantVsSubscriptionControllerService } from './merchantVsSubscriptionController.service';
export * from './merchantVsTaxController.service';
import { MerchantVsTaxControllerService } from './merchantVsTaxController.service';
export * from './merchantVsUserController.service';
import { MerchantVsUserControllerService } from './merchantVsUserController.service';
export * from './metricController.service';
import { MetricControllerService } from './metricController.service';
export * from './moduleCodeController.service';
import { ModuleCodeControllerService } from './moduleCodeController.service';
export * from './orderController.service';
import { OrderControllerService } from './orderController.service';
export * from './orderItemController.service';
import { OrderItemControllerService } from './orderItemController.service';
export * from './paymentController.service';
import { PaymentControllerService } from './paymentController.service';
export * from './paymentMethodController.service';
import { PaymentMethodControllerService } from './paymentMethodController.service';
export * from './paymentOrderItemController.service';
import { PaymentOrderItemControllerService } from './paymentOrderItemController.service';
export * from './posItemCategoryController.service';
import { PosItemCategoryControllerService } from './posItemCategoryController.service';
export * from './posItemController.service';
import { PosItemControllerService } from './posItemController.service';
export * from './posItemRawMaterialController.service';
import { PosItemRawMaterialControllerService } from './posItemRawMaterialController.service';
export * from './posItemUnitController.service';
import { PosItemUnitControllerService } from './posItemUnitController.service';
export * from './posItemVsMerchantController.service';
import { PosItemVsMerchantControllerService } from './posItemVsMerchantController.service';
export * from './printerController.service';
import { PrinterControllerService } from './printerController.service';
export * from './reportController.service';
import { ReportControllerService } from './reportController.service';
export * from './staffAttendanceController.service';
import { StaffAttendanceControllerService } from './staffAttendanceController.service';
export * from './staffAttendanceSettingsController.service';
import { StaffAttendanceSettingsControllerService } from './staffAttendanceSettingsController.service';
export * from './staffController.service';
import { StaffControllerService } from './staffController.service';
export * from './staffMealConfigController.service';
import { StaffMealConfigControllerService } from './staffMealConfigController.service';
export * from './staffMealController.service';
import { StaffMealControllerService } from './staffMealController.service';
export * from './staffMealLedgerController.service';
import { StaffMealLedgerControllerService } from './staffMealLedgerController.service';
export * from './staffProfileController.service';
import { StaffProfileControllerService } from './staffProfileController.service';
export * from './staffShiftController.service';
import { StaffShiftControllerService } from './staffShiftController.service';
export * from './subModuleCodeController.service';
import { SubModuleCodeControllerService } from './subModuleCodeController.service';
export * from './subscriptionController.service';
import { SubscriptionControllerService } from './subscriptionController.service';
export * from './subscriptionModuleController.service';
import { SubscriptionModuleControllerService } from './subscriptionModuleController.service';
export * from './tableMerchantController.service';
import { TableMerchantControllerService } from './tableMerchantController.service';
export * from './taxConfigController.service';
import { TaxConfigControllerService } from './taxConfigController.service';
export * from './uploaderController.service';
import { UploaderControllerService } from './uploaderController.service';
export * from './userController.service';
import { UserControllerService } from './userController.service';
export * from './userRoleController.service';
import { UserRoleControllerService } from './userRoleController.service';
export * from './voucherController.service';
import { VoucherControllerService } from './voucherController.service';
export * from './wastageController.service';
import { WastageControllerService } from './wastageController.service';
export const APIS = [AuthControllerService, BasicErrorControllerService, DashboardControllerService, DepartmentControllerService, ExpensesControllerService, ExpensesHistoryControllerService, FileUploadControllerService, InventoryControllerService, InventoryOrderControllerService, KitchenControllerService, KitchenOrderControllerService, MembershipControllerService, MerchantControllerService, MerchantVsPrinterControllerService, MerchantVsReceiptTemplateControllerService, MerchantVsSubscriptionControllerService, MerchantVsTaxControllerService, MerchantVsUserControllerService, MetricControllerService, ModuleCodeControllerService, OrderControllerService, OrderItemControllerService, PaymentControllerService, PaymentMethodControllerService, PaymentOrderItemControllerService, PosItemCategoryControllerService, PosItemControllerService, PosItemRawMaterialControllerService, PosItemUnitControllerService, PosItemVsMerchantControllerService, PrinterControllerService, ReportControllerService, StaffAttendanceControllerService, StaffAttendanceSettingsControllerService, StaffControllerService, StaffMealConfigControllerService, StaffMealControllerService, StaffMealLedgerControllerService, StaffProfileControllerService, StaffShiftControllerService, SubModuleCodeControllerService, SubscriptionControllerService, SubscriptionModuleControllerService, TableMerchantControllerService, TaxConfigControllerService, UploaderControllerService, UserControllerService, UserRoleControllerService, VoucherControllerService, WastageControllerService];
